import { render, staticRenderFns } from "./Monitoring24JamIcuSectionCard.vue?vue&type=template&id=1791e3d1&scoped=true&"
import script from "./Monitoring24JamIcuSectionCard.vue?vue&type=script&lang=ts&"
export * from "./Monitoring24JamIcuSectionCard.vue?vue&type=script&lang=ts&"
import style0 from "./Monitoring24JamIcuSectionCard.vue?vue&type=style&index=0&id=1791e3d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1791e3d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardSubtitle,VCardText,VDivider})
